import type { Pos } from '../model/pos';

export interface PosApi {
  getPos: () => Promise<Pos[]>;
}

export const POS_API_KEY = 'posApi';
export { GatewayPosApi } from './gateway/gateway-pos-api';
